import { motion, useReducedMotion } from 'framer-motion';

import { cn } from '../../utils/cn';
import pt from '../../locales/pt';
import { LANDING_EASE } from './ScrollReveal';

/** Bar heights % — .pen concept chart (bars, not line) */
const BAR_HEIGHTS = [42, 48, 46, 62, 78, 92];

/**
 * Illustrative 6-month bar chart — Landing section/concept-selfie (.pen).
 * Bars reveal with scaleY while in view (scroll story beat 3).
 */
export function EvolutionChart({ className }) {
  const reduceMotion = useReducedMotion();
  const months = pt.landing.concept.chartMonths;

  return (
    <div
      className={cn(
        'w-full rounded-ds-xl border border-border bg-card p-space-6 shadow-[0_24px_48px_-28px_rgba(28,25,23,0.28)]',
        className,
      )}
    >
      <div className="flex items-start justify-between gap-space-4">
        <div>
          <p className="type-label text-muted-foreground">{pt.landing.concept.chartCaption}</p>
          <p className="type-caption mt-space-1 text-muted-foreground">
            {pt.landing.concept.chartPeriod}
          </p>
        </div>
        <div className="text-right">
          <p className="type-display-metric text-foreground">{pt.landing.concept.chartValue}</p>
          <p className="type-label mt-space-1 font-semibold text-success-700 dark:text-emerald-400">
            {pt.landing.concept.chartDelta}
          </p>
        </div>
      </div>

      <div
        className="mt-space-6 flex h-40 items-end gap-space-2"
        role="img"
        aria-label={`${pt.landing.concept.chartCaption} · ${pt.landing.concept.chartPeriod}`}
      >
        {BAR_HEIGHTS.map((height, index) => (
          <div key={months[index]} className="flex flex-1 flex-col items-center gap-space-2">
            <div className="flex h-32 w-full items-end">
              <motion.span
                className={cn(
                  'origin-bottom w-full rounded-t-ds-sm',
                  index === BAR_HEIGHTS.length - 1 ? 'bg-sage-500' : 'bg-sage-200 dark:bg-sage-800',
                )}
                style={{ height: `${height}%` }}
                initial={reduceMotion ? false : { scaleY: 0 }}
                whileInView={{ scaleY: 1 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{
                  duration: 0.7,
                  delay: index * 0.06,
                  ease: LANDING_EASE,
                }}
              />
            </div>
            <span className="type-caption text-muted-foreground">{months[index]}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
